import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    isTempNotForSale: boolean;
}

export interface ProductTempNotForSaleStatusStyles {
    messageWrapper?: InjectableCss;
    messageText?: TypographyPresentationProps;
    messageTextTitle?: TypographyPresentationProps;
}

export const styles: ProductTempNotForSaleStatusStyles = {
    messageText: { weight: "normal" },
    messageTextTitle: {
        weight: "bold",
        css: css`
            margin-right: 10px;
        `,
    },
};

const TempNotForSaleStatusMessage = ({ isTempNotForSale }: OwnProps) => {
    if (!isTempNotForSale) {
        return null;
    }

    return (
        <StyledWrapper {...styles.messageWrapper}>
            <Typography {...styles.messageTextTitle}>{siteMessage("TempNotForSaleHeading")}</Typography>
            <Typography {...styles.messageText}>{siteMessage("ProductTempNotForSaleMessage")}</Typography>
        </StyledWrapper>
    );
};

export default TempNotForSaleStatusMessage;